export default __webpack_public_path__ + "static/media/41213.81c25e6e.jpg";